import { Game } from '../store/shared/game.model';

// Games ENUM
export const GAMES = {
  LEAGUE_OF_LEGENDS: 'lol',
  FORTNITE: 'fortnite',
  ROCKET_LEAGUE: 'rocket-league',
};

// Since backend aliases are sometimes different we nned to use this function when thats the case.
export function parseGameName(gameAlias) {
  let game = gameAlias;
  if (gameAlias === 'league-of-legends') {
    game = GAMES.LEAGUE_OF_LEGENDS;
  }
  if (Object.values(GAMES).indexOf(game) === -1) {
    console.warn('Game not conected:', game);
  }
  return game;
}

// Ordered Available games
export const availableGames = [GAMES.LEAGUE_OF_LEGENDS, GAMES.FORTNITE, GAMES.ROCKET_LEAGUE];

export const defaultGameDataMap = {
  [GAMES.LEAGUE_OF_LEGENDS]: new Game({
    display_name: 'League of Legends',
    alias: 'lol',
  }),
  [GAMES.FORTNITE]: new Game({
    display_name: 'Fortnite',
    alias: 'fortnite',
  }),
  [GAMES.ROCKET_LEAGUE]: new Game({
    display_name: 'Rocket League',
    alias: 'rocket-league',
  }),
};

export const defaultGameLeaderboardFilters = {
  [GAMES.LEAGUE_OF_LEGENDS]: {
    game: GAMES.LEAGUE_OF_LEGENDS,
    community: 'overall',
    timeFrame: 'currentSeason',
    leaderboardType: 'points',
  },
  [GAMES.FORTNITE]: {
    game: GAMES.FORTNITE,
    community: 'overall',
    timeFrame: 'currentSeason',
    leaderboardType: 'points',
  },
  [GAMES.ROCKET_LEAGUE]: {
    game: GAMES.ROCKET_LEAGUE,
    community: 'overall',
    timeFrame: 'overall',
    leaderboardType: 'rating',
  },
};

export const FORTNITE_LEADERBOARD_TYPES = {
  POINTS: 'points',
  AVG_POSITIONS: 'avgPositions',
  PLAYERS_OUTLIVED: 'playersOutlived',
  TOP_10_STREAK: 'top10Streak',
};

export const LOL_LEADERBOARD_TYPES = {
  POINTS: 'points',
  POSITIVITY: 'positivity',
  HOT_STREAK: 'hotStreak',
  OTP_STATUS: 'optStatus',
  ELO_KING: 'eloKing',
};

export const ROCKET_LEAGUE_LEADERBOARD_TYPES = {
  RATING: 'rating',
  GOALS: 'shots',
  SAVES: 'saves',
  ASSISTS: 'assists',
};

export const gamesLeaderboardFilters = {
  [GAMES.LEAGUE_OF_LEGENDS]: [
    {
      name: 'Points',
      value: LOL_LEADERBOARD_TYPES.POINTS,
    },
    {
      name: 'Positivity',
      value: LOL_LEADERBOARD_TYPES.POSITIVITY,
    },
    {
      name: 'Hot Streak',
      value: LOL_LEADERBOARD_TYPES.HOT_STREAK,
    },
    {
      name: 'Otp Status',
      value: LOL_LEADERBOARD_TYPES.OTP_STATUS,
    },
    {
      name: 'Elo King',
      value: LOL_LEADERBOARD_TYPES.ELO_KING,
    },
  ],
  [GAMES.FORTNITE]: [
    {
      name: 'Points',
      value: FORTNITE_LEADERBOARD_TYPES.POINTS,
    },
    {
      name: 'Top 10 Streak',
      value: FORTNITE_LEADERBOARD_TYPES.TOP_10_STREAK,
    },
    {
      name: 'Average Placement',
      value: FORTNITE_LEADERBOARD_TYPES.AVG_POSITIONS,
    },
    {
      name: 'Players Outlived',
      value: FORTNITE_LEADERBOARD_TYPES.PLAYERS_OUTLIVED,
    },
  ],
  [GAMES.ROCKET_LEAGUE]: [
    {
      name: 'Rating',
      value: ROCKET_LEAGUE_LEADERBOARD_TYPES.RATING,
    },
    {
      name: 'Goals',
      value: ROCKET_LEAGUE_LEADERBOARD_TYPES.GOALS,
    },
    {
      name: 'Saves',
      value: ROCKET_LEAGUE_LEADERBOARD_TYPES.SAVES,
    },
    {
      name: 'Assists',
      value: ROCKET_LEAGUE_LEADERBOARD_TYPES.ASSISTS,
    },
  ],
};
